import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FuseAnimate, FuseAnimateGroup, FusePageCarded } from '@fuse';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import * as Actions from './store/actions';
import classNames from 'classnames';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import * as moment from 'moment';
import RichTextEditor from 'react-rte';

import {
    Card,
    Typography,
    CardContent,
    Divider,
    LinearProgress,
    Button,
    CardActions,
    Icon,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    OutlinedInput,
    MenuItem,
    Popover,
    ListItem,
    List,
    ListSubheader,
    ListItemIcon,
    ListItemText,
    ExpansionPanel,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableHead,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    ListItemSecondaryAction
} from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


const styles = theme => ({
    root: {
        width: '100%',
        '&$expanded': {
            margin: '0px',
        },
        '&:before': {
            display: 'none',
        },
        eventList: {
            fontSize: '10px'
        }

    },
    headerIcon: {
        position: "absolute",
        top: 0,
        left: 24,
        opacity: .04,
        fontSize: 150,
        width: 150,
        height: 150,
        pointerEvents: "none"
    },
});

class CourseEnrollmentDetail extends Component {

    constructor(props) {
        super(props);
        const student_id = this.props.auth.user.data.role_info.link_id;
        const ccc_id = this.props.match.params.company_calendar_course_id;
        this.props.getCourseData(ccc_id, student_id)
    }

    updateEnrollment = (company_calendar_course_id, company_course_student_rel_id) => {
        const student_id = this.props.auth.user.data.role_info.link_id;

        // Check if student is enrolled
        if (company_course_student_rel_id === 0) {
            this.props.submitStudentEnrollment(student_id, company_calendar_course_id);
        } else {
            this.props.removeStudentEnrollment(student_id, company_calendar_course_id);
        }
    }

    getEventSecondaryInfo = (event) => {
        if (event.EventType === 'Quiz') {
            return event.QuestionCount === 1 ? '1 Question' : event.QuestionCount + ' Questions'
        }
        if (event.UnscheduledTodo === 1 || event.StartTime === 'Invalid date') {
            return 'Unscheduled To Do'
        }
        else {
            const minutes = moment(event.EndTime).diff(moment(event.StartTime), 'minutes')
            const returnHours = minutes / 60

            return returnHours.toFixed(1) + ' hours';
        }
    }

    componentWillUnmount = () => {
        this.props.resetCourse()
    }

    render() {
        const { classes, course, prerequisites, courseLayout, theme, instructors, prerequisites_complete } = this.props;
        const rteData = RichTextEditor.createValueFromString(course.CourseEnrollmentDescription, 'html')
        if (!course.is_loaded) return <React.Fragment>Loading...</React.Fragment>;
        const ExpansionPanelSummary = withStyles({
            root: {
                backgroundColor: 'rgba(0, 0, 0, .03)',
                borderBottom: '1px solid rgba(0, 0, 0, .125)',
                marginBottom: -1,
                minHeight: 56,
                '&$expanded': {
                    margin: '0px',
                    minHeight: 56,
                },
            },
            content: {
                '&$expanded': {
                    margin: '12px 0',
                },
            },
            expanded: {},
        })(MuiExpansionPanelSummary);

        const ExpansionPanelDetails = withStyles(theme => ({
            root: {
                // padding: '10px',
                display: 'inline',
            },
        }))(MuiExpansionPanelDetails);

        const layoutContent =
            <div>
                {courseLayout.map(lesson => {
                    const assignmentCount = lesson.EventList.filter(e => e.EventType === 'Assignment').length;
                    const quizCount = lesson.EventList.filter(e => e.EventType === 'Quiz').length;
                    return (
                        <ExpansionPanel style={{ margin: '0px' }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Grid container spacing={8}>
                                    {course.Unscheduled === 1 ?
                                        <Grid item xs={8}><Typography className={classes.heading}>{lesson.LessonName}</Typography></Grid>
                                        :
                                        <React.Fragment>
                                            <Grid item xs={6}><Typography className={classes.heading}>{lesson.LessonName}</Typography></Grid>
                                            <Grid item xs={2}><Typography>{lesson.LessonDate}</Typography></Grid>
                                        </React.Fragment>
                                    }

                                    <Grid item xs={2}><Typography>{assignmentCount} {assignmentCount === 1 ? 'Assignment' : 'Assignments'}</Typography></Grid>
                                    <Grid item xs={2}><Typography>{quizCount} {quizCount === 1 ? 'Quiz' : 'Quizzes'}</Typography></Grid>
                                </Grid>

                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                {lesson.EventList.map(event => {
                                    const assignmentIcon = <Icon style={{ color: 'lightgrey', fontSize: '16px', marginBottom: '-4px', marginRight: '10px' }}>edit</Icon>;
                                    const quizIcon = <Icon style={{ color: 'lightgrey', fontSize: '16px', marginBottom: '-4px', marginRight: '10px' }}>flash_on</Icon>;
                                    //{event.EventType === 'Assignment' ? assignmentIcon : quizIcon} took out icon
                                    return (
                                        <List style={{ marginLeft: '20px', marginRight: '20px' }} >
                                            <ListItemText><Typography className={classes.eventList}>{event.EventName}</Typography></ListItemText>
                                            <ListItemSecondaryAction>{this.getEventSecondaryInfo(event)}</ListItemSecondaryAction>
                                            <Divider />
                                        </List>
                                    )
                                })}
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                    )
                })}
            </div>

        const scheduledStartDate = (
            <React.Fragment>
                <TableRow>
                    <TableCell style={{ width: '30px' }}>Start Date:</TableCell>
                    <TableCell>{course.StartDate}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>End Date:</TableCell>
                    <TableCell>{course.EndDate}</TableCell>
                </TableRow>
            </React.Fragment>
        )

        const selfPacedStartDate = (
            <React.Fragment>
                <TableRow>
                    <TableCell style={{ width: '30px' }}>Availablility Start:</TableCell>
                    <TableCell>{course.StartDate === 'Invalid date' ? 'Unset' : course.StartDate}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Availablility End:</TableCell>
                    <TableCell>{course.EndDate === 'Invalid date' ? 'Unset' : course.EndDate}</TableCell>
                </TableRow>
            </React.Fragment>
        )
        return (
            <div className={classNames(classes.root)}>
                <div className={classNames(classes.header, "relative overflow-hidden flex flex-col items-center justify-center text-center p-16 sm:p-24 h-100 sm:h-144")}
                    style={{ background: "linear-gradient(to right, " + course.Color + " 0%, " + course.Color + " 100%)" }}
                >
                    <FuseAnimate animation="transition.slideUpIn" duration={400} delay={100}>
                        <Typography color={'green'} className="text-24 sm:text-40 font-light" style={{ color: 'yellow' }}>
                            <span style={{ color: this.props.theme.palette.getContrastText(course.Color) }}>{course.CourseName}</span>
                        </Typography>

                    </FuseAnimate>

                    <FuseAnimate duration={400} delay={600}>
                        <Typography variant="subtitle1" className="mt-8 sm:mt-16 mx-auto max-w-512">
                            <span style={{ color: this.props.theme.palette.getContrastText(course.Color) }} className="opacity-75">
                                {course.CourseDescription}
                            </span>
                        </Typography>
                    </FuseAnimate>

                    <Icon style={{ color: this.props.theme.palette.getContrastText(course.Color) }} className={classes.headerIcon}>school</Icon>
                </div>
                <div className="p-24">
                    <Grid container spacing={8}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={8}>
                            {/* <Card > */}
                            <Grid container justify="center" spacing={0}>
                                {prerequisites_complete ?
                                    <Button
                                        onClick={() => this.updateEnrollment(course.company_calendar_course_id, course.company_course_student_rel_id)}
                                        className="justify-start px-32"
                                        style={{ paddingTop: '10px', paddingBottom: '10px', paddingLeft: '60px', paddingRight: '60px' }}
                                        // color='secondary'
                                        variant={'contained'}
                                        color={course.company_course_student_rel_id === 0 ? 'primary' : 'secondary'}
                                    // disabled={course.EnrollmentStatus}
                                    >
                                        {course.company_course_student_rel_id === 0 ? 'Enroll' : 'Leave Course'}
                                    </Button>
                                    :
                                    <span style={{ paddingTop: '10px', paddingBottom: '10px' }}>You haven't met the requirements for this course.</span>
                                }
                                {course.company_course_student_rel_id != 0 ?
                                    <Button
                                        onClick={() => this.props.history.push('/course-dashboard/' + course.company_calendar_course_id + '/' + course.Unscheduled)}
                                        className="justify-start px-32"
                                        style={{ paddingTop: '10px', paddingBottom: '10px', paddingLeft: '60px', paddingRight: '60px' }}
                                        // color='secondary'
                                        variant={'contained'}
                                        color={course.company_course_student_rel_id === 0 ? 'primary' : 'secondary'}
                                    // disabled={course.EnrollmentStatus}
                                    >
                                        {'Go to Course'}
                                    </Button>
                                    : null}
                            </Grid>
                            {/* </Card> */}
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={4}>
                            <Card>
                                <Table>
                                    <TableRow>
                                        <TableCell style={{ width: '30px' }}>Course Type:</TableCell>
                                        <TableCell>{course.Unscheduled === 1 ? 'Self-Paced' : 'Scheduled'}</TableCell>
                                    </TableRow>
                                    {course.Unscheduled === 1 ? selfPacedStartDate : scheduledStartDate}
                                    <TableRow>
                                        <TableCell>Instructors:</TableCell>
                                        <TableCell>{instructors.map(i => {
                                            let primaryI = ''
                                            if (i.PrimaryInstructor === 1) {
                                                primaryI = ' (Primary)'
                                            }
                                            return (
                                                <div>{i.InstructorName + primaryI}</div>
                                            )
                                        })}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Lessons:</TableCell>
                                        <TableCell>{courseLayout.length}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Assignments:</TableCell>
                                        <TableCell>{course.AssignmentCount}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Quizzes:</TableCell>
                                        <TableCell>{course.QuizCount}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Prerequisites:</TableCell>
                                        <TableCell>{prerequisites.map(p => <div>{p.CourseName}</div>)}</TableCell>
                                    </TableRow>
                                </Table>
                            </Card>
                        </Grid>
                        <Grid item xs={4} >
                            <Card style={{ maxHeight: '386px', minHeight: '386px', overflowY: 'scroll' }}>
                                <RichTextEditor
                                    // minHeight={'386px'}
                                    value={rteData}
                                    editorStyle={{ 'minHeight': '384px' }}
                                    readOnly
                                />
                            </Card>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={8}>
                            <Card>
                                {layoutContent}
                            </Card>
                        </Grid>
                        <Grid item xs={2}></Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCourseData: Actions.getCourseData,
        getCompanyCalendarCourseEnrollmentData: Actions.getCompanyCalendarCourseEnrollmentData,
        submitStudentEnrollment: Actions.submitStudentEnrollment,
        removeStudentEnrollment: Actions.removeStudentEnrollment,
        resetCourse: Actions.resetCourse
    }, dispatch);
}

function mapStateToProps({ enrollmentApp, auth }) {
    return {
        course: enrollmentApp.courseEnrollment.course,
        prerequisites: enrollmentApp.courseEnrollment.prerequisites,
        courseLayout: enrollmentApp.courseEnrollment.courseLayout,
        instructors: enrollmentApp.courseEnrollment.instructors,
        prerequisites_complete: enrollmentApp.courseEnrollment.prerequisites_complete,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CourseEnrollmentDetail)));


// WEBPACK FOOTER //
// src/main/content/enrollment/CourseEnrollmentDetail.js